export const MAX_NUMBER_ACCOUNTS = 5;
export const ENABLE_LIMIT_ACCOUNTS = true;
